import { without } from 'lodash';
import { labeled, enumRequired } from '../../util/joi';
import { schema as objectiveTypeBaseReasonOffsetAccount } from './ObjectiveTypeBaseReasonOffsetAccount.schema';
import { ImportantOption, importantOptions } from '../global/ImportantOption.enum';

export const schema = (Joi: any, label: string) => {
  const availableImportantOptions = without(
    importantOptions,
    ImportantOption.none.name,
    ImportantOption.most_important.name,
    ImportantOption.somewhat_important.name,
    ImportantOption.least_important.name
  );
  return Joi.object()
    .keys({
      type: enumRequired(Joi, availableImportantOptions, labeled(label, 'Offset account'))
    })
    .when(
      Joi.object({
        type: Joi.object().keys({ name: Joi.string().valid(ImportantOption?.important?.name) })
      }),
      {
        then: Joi.object({
          reason: objectiveTypeBaseReasonOffsetAccount(
            Joi,
            labeled(label, 'Where having an offset account is important, why? - ')
          )
        })
      }
    );
};

export default {
  schema
};
